export default __webpack_public_path__ + "static/media/sets.863d4507.svg";